import axiosAPI from "../utilities/axios";

const checkoutApiUrl = process.env.REACT_APP_CHECKOUT_API_URL;
export default {
  getPriceTags: async (props: any) => await axiosAPI.get("/price-tags", { params: props }),
  calculateProductPrice: async (props) => await axiosAPI.post("/products", props.data, { baseURL: checkoutApiUrl }),
};
